export const tariffTypeHumanify = (tariffType, t) => {
  switch (tariffType) {
    case 'hour':
      return t('rentals.settings.pricing.hours');
    case 'day':
      return t('rentals.settings.pricing.days');
    case 'week':
      return t('rentals.settings.pricing.weeks');
    case 'month':
      return t('rentals.settings.pricing.months');
    default:
      return tariffType;
  }
}

export default tariffTypeHumanify;
